const ActionType = {
  GET_BRANCHES: 'administration/get-branches',
  GET_BRANCH: 'administration/get-branch',
  CREATE_BRANCH: 'administration/post-branch',
  UPDATE_BRANCH: 'administration/put-branch',
  RESET_BRANCH: 'administration/reset-branch',
}

export default ActionType
